import {useListView} from '../../core/ListViewProvider'
import {EmployersListSearchComponent} from './EmployersListSearchComponent'
import {EmployersListToolbar} from './EmployersListToolbar'

const EmployersListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <EmployersListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        <EmployersListToolbar />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {EmployersListHeader}
